var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{attrs:{"attrs":_vm.$attrs}},[_vm._v(" "+_vm._s(_vm._f("currency")((this.total > 0 ? this.total : 0))))])}
var staticRenderFns = []

export { render, staticRenderFns }